
































































import { addEmployee, getEmpById, editEmployee } from '@/api/employee'
export default {
  data() {
    return {
      optType: '', // 当前操作类型
      ruleForm: {
        name: '',
        username: '',
        phone: '',
        sex: '1',
        idNumber: '',
      },
      rules: {
        name: [{ required: true, message: '请输入员工姓名', trigger: 'blur' }],
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
            valiator: (rule, value, callback) => {
              if (value === '' || !/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            },
          },
        ],
        idNumber: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur',
            valiator: (rule, value, callback) => {
              if (value === '' || !/^\d{17}(\d|X|x)$/.test(value)) {
                callback(new Error('请输入正确的身份证号'))
              } else {
                callback()
              }
            },
          },
        ],
      },
    }
  },
  created() {
    // 获取当前操作类型
    this.optType = this.$route.query.id ? 'update' : 'add'
    // 如果是编辑员工，根据id查询员工信息
    if (this.optType === 'update') {
      // 根据id查询员工信息
      getEmpById(this.$route.query.id).then((res) => {
        if (res.data.code === 1) {
          this.ruleForm = res.data.data
        }
      })
    }
  },
  methods: {
    // 保存员工
    submitForm(form, isContinue) {
      this.$refs[form].validate((valid) => {
        // 表单校验
        if (valid) {
          // 提交表单数据
          if (this.optType === 'add') {//新增员工
            addEmployee(this.ruleForm).then((res) => {
              if (res.data.code === 1) {
                this.$message.success('新增员工成功')
                if (isContinue) {
                  // 清空表单数据
                  this.ruleForm = {
                    name: '',
                    username: '',
                    phone: '',
                    sex: '1',
                    idNumber: '',
                  }
                } else {
                  // 跳转到员工列表页面
                  this.$router.push('/employee')
                }
              } else {
                this.$message.error(res.data.msg)
              }
            })
          } else { // 修改员工
            editEmployee(this.ruleForm).then((res) => {
              if (res.data.code === 1) {
                this.$message.success('修改员工成功')
                // 跳转到员工列表页面
                this.$router.push('/employee')
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        }
      })
    },
  },
}
